import { morphForWords } from 'components/shared/processes'

export const useGetMinutesFromSec = (seconds: number) => {
	const isMinutes = seconds >= 60
	const value = isMinutes ? (seconds / 60).toFixed(0) : seconds
	const morph = isMinutes
		? morphForWords(Number(value), ['минута', 'минуты', 'минут'])
		: morphForWords(seconds, ['секунда', 'секунды', 'секунд'])
	return { morph, value }
}
